var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"home"},[_c('home-content-carousel'),_c('home-content-introduction'),_c('home-content-step'),_c('home-content-model'),(false)?_c('home-content-professional'):_vm._e(),(false)?_c('home-content-core-technology'):_vm._e()],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }